export default __webpack_public_path__ + "ad85789.png";